'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_LIGHT_COLOR = '#FFFFFF';
const DEFAULT_DARK_COLOR = '#000000';
// Based on https://stackoverflow.com/questions/11867545/change-text-color-based-on-brightness-of-the-covered-background-area
const getContrastColor = (bgColor, lightColor = DEFAULT_LIGHT_COLOR, darkColor = DEFAULT_DARK_COLOR) => {
    const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
    if (color.length !== 6) {
        throw new Error(`Invalid HEX color "${bgColor}" in sparted mail manager.`);
    }
    const r = parseInt(color.substring(0, 2), 16); // hexToR
    const g = parseInt(color.substring(2, 4), 16); // hexToG
    const b = parseInt(color.substring(4, 6), 16); // hexToB
    // Values from https://www.w3.org/TR/AERT/#color-contrast
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
};

exports.getContrastColor = getContrastColor;
//# sourceMappingURL=get-contrast-color.js.map
